export default function FloatSlider() {
  const section = document.getElementById('capture-section')
  const list = document.getElementById('slider-list')
  const boxUl = document.getElementById('slider-box')
  const sourceContainer = document.querySelector('.a-container')

  if (!section || !list || !boxUl) return

  const items = Array.from(list.querySelectorAll('li'))
  const isMobileQuery = window.matchMedia(`(max-width: 767px)`)
  const STICKY_OFFSET = 200
  let currentTranslateX = 0
  let resizeTimeout

  function debounce(callback) {
    clearTimeout(resizeTimeout)

    resizeTimeout = setTimeout(callback, 150)
  }

  function getCurrentMaxWidth(currentWindowWidth) {
    const BREAKPOINTS = [
      { minWidth: 912, maxWidth: 912 },
      { minWidth: 944, maxWidth: 944 },
      { minWidth: 1224, maxWidth: 1224 }
    ]

    let activeMaxWidth = null

    ;[...BREAKPOINTS]

      .sort((a, b) => a.minWidth - b.minWidth)

      .forEach((bp) => {
        if (currentWindowWidth >= bp.minWidth) activeMaxWidth = bp.maxWidth
      })

    return activeMaxWidth
  }

  function setDynamicPadding() {
    if (isMobileQuery.matches) {
      boxUl.style.paddingRight = ''

      return
    }

    const viewportWidth = window.innerWidth

    const currentMaxWidth = getCurrentMaxWidth(viewportWidth)

    if (currentMaxWidth && viewportWidth > currentMaxWidth) {
      boxUl.style.paddingRight = `${viewportWidth - currentMaxWidth}px`
    } else {
      boxUl.style.paddingRight = ''
    }
  }

  function setDynamicPaddingFromMargin() {
    if (isMobileQuery.matches) {
      boxUl.style.paddingLeft = '16px'

      return
    }

    if (!sourceContainer) return

    const computedStyle = window.getComputedStyle(sourceContainer)

    const paddingLeft =
      parseFloat(computedStyle.marginLeft) +
      parseFloat(computedStyle.paddingLeft)

    boxUl.style.paddingLeft = `${paddingLeft}px`
  }

  function updateLayout() {
    setDynamicPadding()
    setDynamicPaddingFromMargin()

    const listWidth = list.scrollWidth
    const boxWidth = boxUl.offsetWidth
    const paddingLeftVal = parseFloat(boxUl.style.paddingLeft || 0)
    const maxHorizontal = listWidth - boxWidth + paddingLeftVal

    return maxHorizontal
  }

  function updateScrollUI(maxHorizontal) {
    currentTranslateX = Math.max(0, Math.min(currentTranslateX, maxHorizontal))

    list.style.transform = `translateX(-${currentTranslateX}px)`

    if (items.length > 0) {
      const itemWidth = items[0].offsetWidth + 24
      const activeIdx = Math.round(currentTranslateX / itemWidth)

      items.forEach((item, idx) =>
        item.classList.toggle('active', idx === activeIdx)
      )
    }
  }

  function handleWheel(e) {
    if (window.innerWidth > 1023) {
      if (isMobileQuery.matches) return

      const maxHorizontal = updateLayout()
      const rect = section.getBoundingClientRect()
      const atStart = currentTranslateX <= 0
      const atEnd = currentTranslateX >= maxHorizontal
      const scrollingDown = e.deltaY > 0
      const scrollingUp = e.deltaY < 0

      const shouldCapture =
        (scrollingDown && !atEnd && rect.top <= STICKY_OFFSET + 2) ||
        (scrollingUp && !atStart && rect.top >= STICKY_OFFSET - 2)

      if (shouldCapture) {
        e.preventDefault()

        document.body.classList.add('is-locked')
        section.classList.add('is-sticky')

        const targetY = window.pageYOffset + rect.top - STICKY_OFFSET

        window.scrollTo({ top: targetY, behavior: 'auto' })

        currentTranslateX += e.deltaY

        updateScrollUI(maxHorizontal)
      } else {
        document.body.classList.remove('is-locked')

        if (rect.top > STICKY_OFFSET + 10 || rect.top < STICKY_OFFSET - 10) {
          section.classList.remove('is-sticky')
        }
      }
    }
  }

  window.addEventListener('wheel', handleWheel, { passive: false })

  window.addEventListener('resize', () =>
    debounce(() => {
      const max = updateLayout()

      updateScrollUI(max)
    })
  )

  const max = updateLayout()

  updateScrollUI(max)
}
